import type { ReactNode } from "react";

/**
 * An empty table or list.
 *
 * From the design system (10): the heading says what is missing, one sentence
 * explains, one button resolves it. No illustrations, and never "Nema ničega
 * ovdje" — which tells somebody nothing about what to do next.
 */
export function EmptyState({
  naslov,
  objasnjenje,
  akcija,
}: {
  naslov: string;
  objasnjenje: string;
  akcija?: ReactNode;
}) {
  return (
    <div className="avm-empty">
      <p className="avm-empty__title">{naslov}</p>
      <p className="avm-empty__desc">
        {objasnjenje}
      </p>
      {akcija ? <div className="pt-2">{akcija}</div> : null}
    </div>
  );
}
